"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotStreakEffectHandler = exports.HotStreakEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class HotStreakEffectArgs {
    constructor(percentIncrease = 30, skipAnimation = false) {
        this.percentIncrease = percentIncrease;
        this.skipAnimation = skipAnimation;
        this.__type = EffectType_1.EffectType.HotStreak;
        this.__typeName = "HotStreak";
        this.name = "Hot Streak";
        this.harmful = false;
    }
}
exports.HotStreakEffectArgs = HotStreakEffectArgs;
let HotStreakEffectHandler = class HotStreakEffectHandler {
    apply(sequence, container, state) {
        if (state.args.skipAnimation) {
            state.meta.effectId = container.applyBuff({
                creatorId: state.creatorId,
                targetId: state.targetId,
                effect: new _1.DamageAmplifyEffectArgs(state.args.percentIncrease),
                duration: Duration_1.Duration.Permanent,
                hidden: true,
                sequence
            });
            return;
        }
        container.applyAbilityAnimation({
            sequence,
            animatedId: state.targetId,
            abilityKey: "HotStreak",
            fallback: "casting",
            onAnimated(sequence) {
                state.meta.effectId = container.applyBuff({
                    sequence,
                    creatorId: state.creatorId,
                    targetId: state.targetId,
                    effect: new _1.DamageAmplifyEffectArgs(state.args.percentIncrease),
                    duration: Duration_1.Duration.Permanent,
                    hidden: true
                });
            }
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.effectId);
    }
};
HotStreakEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.HotStreak)
], HotStreakEffectHandler);
exports.HotStreakEffectHandler = HotStreakEffectHandler;
